import { encrypt } from '@/lib'
import { UserModel } from '@/models/db'
import bcrypt from 'bcrypt'
import { NextFunction, Request, Response } from 'express'
import { validationResult } from 'express-validator'

export const loginCtrl = async (
  req: Request,
  res: Response,
  next: NextFunction,
) => {
  const errors = validationResult(req)
  if (!errors.isEmpty()) {
    return res.status(400).json({ errors: errors.array() })
  }
  try {
    const { username, password } = req.body
    const userexist = await UserModel.findUnique({
      where: { username: username },
    })
    if (!userexist) {
      return res.status(400).json({ message: 'User not found' })
    }
    //check password
    const validatePassword = await bcrypt.compare(password, userexist.password)
    if (!validatePassword) {
      return res
        .status(401)
        .json({ message: 'username or password is incorrect' })
    }
    //generate token
    const token = await encrypt({
      _id: userexist.id,
      username: userexist.username,
    })

    const updatedLastLogin = await UserModel.update({
      where: { id: userexist.id },
      data: { lastLogin: new Date() },
    })

    if (!updatedLastLogin) {
      return res.status(500).json({ message: 'Internal server error' })
    }

    return res.status(200).json({
      message: 'Logged in successfully',
      username: username,
      accesstoken: token,
      role: userexist.role,
      _id: userexist.id,
    })
  } catch (err) {
    next(new Error((err as Error).message))
  }
}
